import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async upsert(data) {
        try
        {            
            const response = await axios.post(`Employment`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })                   
            return response
        }
        catch (error)
        {
            console.log('employment upsert error')
            throw error
        }
    },
    async getByUser() {
        try
        {            
            const response = await axios.get(`Employment`)            
            return response
        }
        catch (error)
        {
            console.log('Employment getByUser error')
            throw error
        }
    },
    async getBySelectedUser(userId) {
        try
        {            
            const response = await axios.get(`Employment/${userId}`)            
            return response
        }
        catch (error)
        {
            console.log('Employment getBySelectedUser error')
            throw error
        }
    },
    async getHistoryByUser(userId) {
        try
        {            
            const response = await axios.get(`Employment/history/${userId}`)            
            return response
        }
        catch (error)
        {
            console.log('Employment getHistoryByUser error')
            throw error
        }
    },
}
